import React, { useState } from 'react';
import fr from 'facet-rest';
import MyScenarioExampleImage from 'Assets/Images/my-scenario-example.png';
import Image from 'Components/ComponentLibrary/Atoms/Image';
import StackItem from 'Components/ComponentLibrary/Atoms/Layout/StackItem';
import VerticalStack from 'Components/ComponentLibrary/Atoms/Layout/VerticalStack';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import Transition from 'Components/ComponentLibrary/Atoms/Transition';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Container from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Container';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import HeaderBar from 'Components/ComponentLibrary/Molecules/HeaderBar';
import PointsOfInterestCard from 'Components/ComponentLibrary/Molecules/PointsOfInterestCard';
import StepNavigator from 'Components/ComponentLibrary/Molecules/StepNavigator';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { pickFunction } from 'Helpers/Affordances';
import { Path } from 'Icons/Path';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const Layout = () => {
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const {
    loadPageContentLink,
    setPageContentCollection,
    isPageContentLoading,
    pageContentResource: resource,
  } = usePageContentContext();
  const templateName = resource.type();
  const canPost = resource.meta().action('POST');
  const isLoading = isPageContentLoading || loading;

  const handleNext = async () => {
    logStandardizedEvent(categories.wizard, eventTypes.click, 'continue', { eventProperties: { templateName } });
    setErrors([]);
    setLoading(true);
    try {
      const updatedColl = await resource.submit();
      await setPageContentCollection(updatedColl);
    } catch (e) {
      setLoading(false);
      setErrors(e.errors);
    }
    setLoading(false);
  };

  const maybeHandlePrevious = pickFunction(resource, {
    [fr.relationships.previousLink.name]: () => async () => {
      const previousLink = resource
        .relationship(fr.relationships.previousLink.name)
        .link('related');

      logStandardizedEvent(categories.wizard, eventTypes.click, 'back', { eventProperties: { templateName } });
      await loadPageContentLink(previousLink);
    },
    [fr.relationships.default.name]: () => null,
  });

  // TODO: get from server
  const pointsOfInterest = [
    'Weigh the pros and cons',
    'Check out the details',
    'Reach out to us with questions',
    'Select the scenario you want to make reality',
  ];

  return (
    <VerticalStack height="screen" spacing={3}>
      <StackItem>
        <HeaderBar
          test={`facet-plan-header-${templateName}`}
          title={'Scenario Selection'}
        />
      </StackItem>
      <StackItem fillsSpace>
        <Transition>
          <Container maxWidth="xs">
            <VerticalStack spacing={3}>
              <StackItem>
                <Box align="center">
                  <Icon boxSize="lg" icon={Path} />
                </Box>
              </StackItem>
              <StackItem>
                <Text
                  align="center"
                  test="facet-plan-client-scenario-review-header"
                  text={resource.attr('title')}
                  variant="h1"
                  weight="bold"
                />
              </StackItem>
              <StackItem>
                <Image
                  alt="Scenario screenshot examples"
                  src={MyScenarioExampleImage}
                />
              </StackItem>
              <StackItem>
                <PointsOfInterestCard pointsOfInterest={pointsOfInterest} />
              </StackItem>
            </VerticalStack>
          </Container>
        </Transition>
      </StackItem>
      <StackItem hidden={errors.length === 0}>
        <MetaFormInline
          noIndividualSubmitButtons
          resource={resource}
          LayoutProps={{
            hideErrorList: true,
          }}
          errorsOverride={errors}
        />
      </StackItem>
      <StackItem position="bottom">
        <StepNavigator
          disabled={isLoading}
          isLoading={isLoading}
          onNext={canPost ? handleNext : undefined}
          onPrevious={maybeHandlePrevious}
        />
      </StackItem>
    </VerticalStack>
  );
};

Layout.defaultProps = {};
Layout.propTypes = {};

export default Layout;
